import type {ListClientsSearchInput} from "./list-clients.schema";

import {keepPreviousData, useQuery} from "@tanstack/react-query";

import {listClientsQueryOptions} from "./list-clients.query-options";

export function useListClients(search: ListClientsSearchInput) {
  return useQuery({
    ...listClientsQueryOptions(search),
    placeholderData: keepPreviousData,
  });
}
